// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"74":"83dfbcc2","79":"83dfbcc2","146":"83dfbcc2","267":"83dfbcc2","303":"83dfbcc2","368":"83dfbcc2","605":"83dfbcc2","606":"770d132f","648":"208c01aa","681":"83dfbcc2","688":"83dfbcc2","761":"83dfbcc2"}[chunkId] + ".chunk.css";
};